import React, { Component } from 'react';

class ErrorBoundary extends Component {
    constructor(props){
        super(props);

        this.state = {  hasError: false, error: '', info: '' }
    }

    componentDidCatch(error, errorInfo){
        this.setState({ hasError: true, error: error, info: errorInfo });
        console.log("Error Generico", error, errorInfo);
    }

    render(){
        return(
            this.state.hasError ? (
                <h1 style={{margin: 113}}>{"Hubo un error al cargar el componente ("+this.state.error.toString()+")"} </h1>
            ) : (
                this.props.children
                )
        )
    }
}

export default ErrorBoundary